<template>
  <div class="container_log">
    <b-container class="header">
      <b-row>
        <b-col>
          <div @click="back()" style="cursor:pointer;margin-top:20px;">
            <font-awesome-icon style="font-size:28px;cursor:pointer;" :style="{color: getCssColor('primary_bt')}" :icon="['fal', 'times']"/>
          </div>
        </b-col>
      </b-row>
    </b-container>
    <b-container>
      <b-row class="content_form">
        <b-col cols="12" style="text-align:center;color:#2C2A29;font-size:16px;font-weight: 500;">
          ALTERAR SENHA
        </b-col>
        <b-col cols="12">
          <font-awesome-icon class="imgInputIcon" :icon="['fal', 'key']" :style="{color: getCssColor('secondary_bt')}"/>
          <input type="password" @blur="validatePassword()" :class="{invalidForm: invalidPassword}"  class="inputFormText" name="password" placeholder="Senha" v-model="password"/>
          <div v-if="invalidPassword" class="messageInputError">{{messageErrorPassword}}</div>
        </b-col>
        <b-col cols="12">
          <font-awesome-icon class="imgInputIcon" :icon="['fal', 'key']" :style="{color: getCssColor('secondary_bt')}"/>
          <input type="password" @keyup.enter="changePass()" @blur="validatePassword2()" :class="{invalidForm: invalidPassword2}" class="inputFormText" name="password2" placeholder="Repetir Senha" v-model="password2"/>
          <div v-if="invalidPassword2" class="messageInputError">{{messageErrorPassword2}}</div>
        </b-col>
        <b-col cols="12">
          <div @click="changePass()" :style="{backgroundColor: getCssColor('secondary_bt')}"
            style="margin-top:20px;color:#FFFFFF; cursor:pointer; font-size:14px; font-weight:500; border-radius:4px; height:40px;line-height:40px;text-align:center;">
            CONTINUAR
          </div>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
import colors from '@/mixins/colors'
import UserConn from '@/connection/user'
import { EventBus } from '@/behaviours/event-bus'
import navigation from '@/mixins/navigation'

export default {
  name: 'ChangePass',
  data () {
    return {
      password: null,
      invalidPassword: false,
      messageErrorPassword: 'O campo senha é obrigatório, precisa ter 6 dígitos',
      password2: null,
      invalidPassword2: false,
      messageErrorPassword2: 'As senhas não conferem',
    }
  },
  mixins: [colors, navigation],

  methods: {
    async changePass () {
      let code = this.$store.state.tempCode
      let userId = this.$store.state.tempId
      if (this.validateForm ()) {
        let result = await UserConn.changePass(this.password, code, userId)
        if (!result.error) {
          this.$router.push({path: '/login'})
        } else {
          EventBus.$emit('showAlert', 'error', 'Erro ao alterar senha')
        }
      }
    },
    validateForm () {
      if (
        !this.validatePassword() &&
        !this.validatePassword2()
      ) {
        return true
      } else {
        return false
      }
    },
    validatePassword () {
      this.invalidPassword = !this.password || this.password.length < 6
      return this.invalidPassword
    },
    validatePassword2 () {
      this.invalidPassword2 = !this.password2 || this.password2 !== this.password
      return this.invalidPassword2
    }
  }
}
</script>

<style lang="scss" scoped>

.form_container {
  position:relative;
  width: calc(100% - 20px);
  max-width:434px;
  line-height: 20px;
  margin: 0px auto;
}
.container_log {
  width:100vw;
  // max-width: 1330px;
  min-height: 100vh;
  background-color: #FFFFFF;
}
.header{
  width : calc(100vw);
  // max-width: 1330px;
  position: -webkit-sticky; /* Safari */
  position: sticky;
  height: 46px;
  text-align:right;
  top: 10px;
}

.content_form {
  padding:10px 20px;
}

.inputFormText {
    width: calc(100%);
    font-size:16px;
    height:30px;
    padding-left:30px;
    color: #2C2A29;
    background-color: transparent;
    border:0px;
    border-bottom: 1px solid #2C2A29;
  }
.imgInputIcon {
    position:relative;
    left:5px;
    top:26px;
    font-size:16px;
  }

  .imgSelectIcon {
    font-size:16px;
    margin-left:5px;
  }

  input::placeholder {
    font-size:16px;
    //color: #2C2A29;
  }

  input:focus {
    outline: none;
    border:0px;
    border-bottom: 1px solid #5E2B8B;
  }

.messageInputError {
  color: rgb(255, 88, 88);
  font-size:12px;
  padding:4px;
}

.invalidForm {
  border-bottom: 1px solid rgb(255, 88, 88)!important;
}
</style>

